import { toast } from 'react-toastify';
import { readProfile } from '../../utils/authUtils';
import { convertPageableResponse } from '../../utils/responseMapper';
import * as api from '../api/meApi';
import * as analytics from '../constants/analyticsConstants';
import * as vehiclesTypes from '../constants/vehiclesConstants';
import * as visitsTypes from '../constants/visitsConstants';
import { hydrateAndDispatch } from './authHelpers';
import { refreshUserDataAction } from './refreshTokenAction';

export const updateMyPasswordAction = (passwordRequest) => async (dispatch) => {
  try {
    const { error, data } = await api.changePassword(passwordRequest);
    if (error) {
      throw new Error(error);
    }
    dispatch(refreshUserDataAction(data));
    toast.success('Пароль було успішно змінено');
  } catch (error) {
    toast.error(error?.message ? error.message : 'Не вдалося змінити пароль');
  }
};

export const updateMyInformationAction = (meRequest) => async (dispatch) => {
  try {
    const { error } = await api.updateMe(meRequest);
    if (error) {
      throw new Error(error);
    }
    const accessToken = readProfile()?.accessToken;
    if (accessToken) {
      await hydrateAndDispatch(dispatch, accessToken);
    }
    toast.success('Інформацію було успішно змінено');
  } catch (error) {
    toast.error(error?.message ? error.message : 'Не вдалося змінити пароль');
  }
};

export const getMyVehiclesActions = (search) => async (dispatch) => {
  dispatch({ type: vehiclesTypes.GET_VEHICLES_REQUEST });
  try {
    const { error, data } = await api.getMyVehicles(search);
    if (error) {
      throw new Error(error);
    }

    const { content, ...paginationData } = data;
    const pageable = convertPageableResponse(paginationData);

    dispatch({
      type: vehiclesTypes.GET_VEHICLES_SUCCESS,
      payload: {
        data: content,
        pageable: pageable,
      },
    });
  } catch (error) {
    toast.error(error?.message ? error.message : 'Не вдалося завантажити список автомобілів');
    dispatch({ type: vehiclesTypes.GET_VEHICLES_FAILURE });
  }
};

export const getMyVisitsActions = (search) => async (dispatch) => {
  dispatch({ type: visitsTypes.GET_VISITS_REQUEST });
  try {
    const { error, data } = await api.getMyVisits(search);
    if (error) {
      throw new Error(error);
    }

    const { content, ...paginationData } = data;
    const pageable = convertPageableResponse(paginationData);

    dispatch({
      type: visitsTypes.GET_VISITS_SUCCESS,
      payload: {
        data: content,
        pageable: pageable,
      },
    });
  } catch (error) {
    toast.error(error?.message ? error.message : 'Не вдалося завантажити список візитів');
    dispatch({ type: visitsTypes.GET_VISITS_FAILURE });
  }
};

export const getMyAnalytics = () => async (dispatch) => {
  dispatch({ type: analytics.GET_ANALYTICS_REQUEST });
  try {
    const { error, data } = await api.getMyAnalytics();
    if (error) {
      throw new Error(error);
    }
    dispatch({
      type: analytics.GET_ANALYTICS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    toast.error(error?.message ? error.message : 'Не вдалося завантажити аналітику');
    dispatch({ type: analytics.GET_ANALYTICS_FAILURE });
  }
};

export const clearMyAnalyticsAction = () => async (dispatch) => {
  dispatch({ type: analytics.CLEAR_ANALYTICS });
};

export const setVisitStatus = (status) => async (dispatch) => {
  dispatch({
    type: visitsTypes.SET_VISITS_STATUS,
    payload: status,
  });
};
